import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { Container, Grid } from "@mui/material";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
  },
}));

const skillProgress = {
  backgroundColor: "#1d293a",
  borderRadius: "5px",
};

const skill = {
  fontSize: "20px",
  marginLeft: "20px",
};

const Progress = {
  marginLeft: "auto",
  marginRight: "10px",
  padding: "10px",
  backgroundColor: "#1a90ff",
  borderRadius: "5px",
};

const skillContainer = {
  backgroundColor: "#111a28",
  color: "#fff",
  paddingTop: "5%",
};

const Skills = () => {
  return (
    <Box id="skill" style={skillContainer}>
      <h1 className="pseudo">My Skills</h1>
      <Container sx={{ flexGrow: 1 }}>
        <ul className="nav skills-button" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="web-tab"
              data-bs-toggle="tab"
              data-bs-target="#web"
              type="button"
              role="tab"
              aria-controls="web"
              aria-selected="false"
            >
              Web
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="programming-tab"
              data-bs-toggle="tab"
              data-bs-target="#programming"
              type="button"
              role="tab"
              aria-controls="programming"
              aria-selected="false"
            >
              Programming
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="others-tab"
              data-bs-toggle="tab"
              data-bs-target="#others"
              type="button"
              role="tab"
              aria-controls="others"
              aria-selected="false"
            >
              Others
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="tools-tab"
              data-bs-toggle="tab"
              data-bs-target="#tools"
              type="button"
              role="tab"
              aria-controls="tools"
              aria-selected="false"
            >
              Tools
            </button>
          </li>
        </ul>

        <div className="tab-content">
          <div
            className="tab-pane active"
            id="web"
            role="tabpanel"
            aria-labelledby="web-tab"
          >
            <Grid className="pt-5" container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>HTML5</p>
                    <p style={Progress}>90%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={90} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>CSS3</p>
                    <p style={Progress}>90%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={90} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Bootstrap v5.1</p>
                    <p style={Progress}>90%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={90} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Tailwind CSS</p>
                    <p style={Progress}>75%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={75} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>JavaScript</p>
                    <p style={Progress}>85%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={85} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>TypeScript</p>
                    <p style={Progress}>75%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={75} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Material UI</p>
                    <p style={Progress}>80%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={80} />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box>
                  <Box style={skillProgress}>
                    <Box sx={{ display: "flex" }}>
                      <p style={skill}>ReactJS</p>
                      <p style={Progress}>90%</p>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <BorderLinearProgress variant="determinate" value={90} />
                    </Box>
                  </Box>
                  <br />
                  <Box style={skillProgress}>
                    <Box sx={{ display: "flex" }}>
                      <p style={skill}>Redux Toolkit</p>
                      <p style={Progress}>50%</p>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <BorderLinearProgress variant="determinate" value={50} />
                    </Box>
                  </Box>
                  <br />
                  <Box style={skillProgress}>
                    <Box sx={{ display: "flex" }}>
                      <p style={skill}>NodeJS </p>
                      <p style={Progress}>80%</p>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <BorderLinearProgress variant="determinate" value={80} />
                    </Box>
                  </Box>
                  <br />
                  <Box style={skillProgress}>
                    <Box sx={{ display: "flex" }}>
                      <p style={skill}>ExpressJS</p>
                      <p style={Progress}>90%</p>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <BorderLinearProgress variant="determinate" value={90} />
                    </Box>
                  </Box>
                  <br />
                  <Box style={skillProgress}>
                    <Box sx={{ display: "flex" }}>
                      <p style={skill}>NextJS</p>
                      <p style={Progress}>90%</p>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <BorderLinearProgress variant="determinate" value={90} />
                    </Box>
                  </Box>
                  <br />
                  <Box style={skillProgress}>
                    <Box sx={{ display: "flex" }}>
                      <p style={skill}>MongoDB</p>
                      <p style={Progress}>85%</p>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <BorderLinearProgress variant="determinate" value={85} />
                    </Box>
                  </Box>
                  <br />
                  <Box style={skillProgress}>
                    <Box sx={{ display: "flex" }}>
                      <p style={skill}>Mongoess</p>
                      <p style={Progress}>75%</p>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <BorderLinearProgress variant="determinate" value={75} />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </div>
          <div
            className="tab-pane"
            id="programming"
            role="tabpanel"
            aria-labelledby="programming-tab"
          >
            <Grid className="pt-5" container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>JavaScript</p>
                    <p style={Progress}>85%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={85} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>TypeScript</p>
                    <p style={Progress}>75%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={75} />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>NodeJS</p>
                    <p style={Progress}>80%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={80} />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </div>
          <div
            className="tab-pane"
            id="others"
            role="tabpanel"
            aria-labelledby="others-tab"
          >
            <Grid className="pt-5" container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Firebase</p>
                    <p style={Progress}>90%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={90} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Netlify</p>
                    <p style={Progress}>90%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={90} />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Vercel</p>
                    <p style={Progress}>90%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={90} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Heroku</p>
                    <p style={Progress}>90%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={90} />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </div>
          <div
            className="tab-pane"
            id="tools"
            role="tabpanel"
            aria-labelledby="tools-tab"
          >
            <Grid className="pt-5" container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Git</p>
                    <p style={Progress}>90%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={90} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Github</p>
                    <p style={Progress}>90%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={90} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Vs Code</p>
                    <p style={Progress}>90%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={90} />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Photoshop.</p>
                    <p style={Progress}>75%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={75} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Figma.</p>
                    <p style={Progress}>85%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={85} />
                  </Box>
                </Box>
                <br />
                <Box style={skillProgress}>
                  <Box sx={{ display: "flex" }}>
                    <p style={skill}>Chrome Dev Tool</p>
                    <p style={Progress}>80%</p>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={80} />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </div>
        </div>
      </Container>
    </Box>
  );
};

export default Skills;
